// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"1f2f4f2b","651":"5cbb226d","675":"37766e49","860":"d6a2da83"}[chunkId] + ".chunk.js";
};